// Brand-wise dealership data for Nago International.
// Each brand has: id, name, logo, category, tagline, products (with real images, ISO grades, sizes).

export const BRANDS = [
  {
    id: "velvex",
    name: "Velvex",
    logo: "/images/brands/velvex.png",
    category: "Industrial Lubricants & Metal Working Fluids",
    parent: "New Age Lubricants & Additives",
    tagline: "High-performance cutting fluids, hydraulic and gear oils for demanding industrial applications.",
    description:
      "Velvex is a trusted name in industrial lubricants — soluble cutting oils, synthetic and semi-synthetic coolants, hydraulic oils and specialty fluids engineered for productivity and long tool life.",
    productHighlights: [
      "Semi-synthetic & synthetic cutting oils (Prime, EP-25 Plus, EP-70)",
      "Neat cutting oils (Cutvel SPL, S-Plus)",
      "Industrial hydraulic oils (Hydovel AW, Hydrovel)",
      "Pack sizes: 20 L, 26 L, 50 L, 210 L barrel",
    ],
    products: [
      { name: "Semi Synthetic Prime", spec: "Soluble Cutting Oil", size: "20 L", image: "/images/products/velvex/hydraulic-oil.png" },
      { name: "Semi Synthetic Prime", spec: "Soluble Cutting Oil", size: "26 L", image: "/images/products/velvex/semi-synth-prime-26l.png" },
      { name: "Semi Synthetic Prime", spec: "Soluble Cutting Oil", size: "210 L Barrel", image: "/images/products/velvex/semi-synth-prime-210l.png" },
      { name: "Cutvel S-Plus", spec: "Soluble Cutting Oil", size: "20 L", image: "/images/products/velvex/cutvel-s-plus.png" },
      { name: "Synth Cut EP-25 Plus", spec: "Semi-Synthetic HP", size: "210 L Barrel", image: "/images/products/velvex/synth-cut-ep25-plus-210l.png" },
      { name: "Synth Cut EP-70", spec: "High-Performance Cutting Fluid", size: "20 L", image: "/images/products/velvex/synth-cut-ep70.png" },
      { name: "Cutvel-SPL", spec: "Soluble Cutting Oil", size: "26 L", image: "/images/products/velvex/cutvel-spl-26l.png" },
      { name: "Hydovel AW 32", spec: "Hydraulic Oil ISO VG 32", size: "210 L Barrel", image: "/images/products/velvex/hydovel-aw-32.png" },
      { name: "Hydrovel 68", spec: "Hydraulic Oil ISO VG 68", size: "26 L", image: "/images/products/velvex/hydrovel-68-26l.png" },
      { name: "Hydrovel 68", spec: "Hydraulic Oil ISO VG 68", size: "210 L Barrel", image: "/images/products/velvex/hydrovel-68-210l.png" },
      { name: "Synth Cut EP-25 Plus", spec: "Semi-Synthetic HP", size: "20 L", image: "/images/products/velvex/velvex-product-a.png" },
      { name: "Cutting Fluid", spec: "Industrial Coolant", size: "20 L", image: "/images/products/velvex/velvex-product-b.png" },
      { name: "Cutting Fluid", spec: "Industrial Coolant", size: "26 L", image: "/images/products/velvex/velvex-product-c.png" },
      { name: "Industrial Coolant", spec: "Metal Working Fluid", size: "26 L", image: "/images/products/velvex/velvex-product-d.png" },
      { name: "Industrial Coolant", spec: "Metal Working Fluid", size: "50 L", image: "/images/products/velvex/velvex-product-e.png" },
      { name: "Specialty Lubricant", spec: "Industrial Oil", size: "20 L", image: "/images/products/velvex/velvex-product-f.png" },
    ],
    grades: {
      title: "Available Grades",
      columns: ["Product Type", "Grades / ISO VG"],
      rows: [
        ["Hydraulic Oils", "VG 10, VG 22, VG 32, VG 46, VG 68, VG 100, VG 150, VG 220, VG 320, VG 460"],
        ["Cutting Fluids", "Semi-synthetic Prime, EP-25 Plus, EP-70, Cutvel SPL, S-Plus"],
        ["Way Lubricants", "VG 32, VG 68, VG 220"],
      ],
    },
  },
  {
    id: "divyol",
    name: "Divyol",
    logo: "/images/brands/divyol.png",
    category: "Industrial Lubricants & Coolants",
    parent: "Gandhar Oil Refinery India Ltd.",
    tagline: "Full-range industrial lubricants from a listed Indian lubricants major.",
    description:
      "Divyol, powered by Gandhar Oil Refinery India Ltd., manufactures a wide portfolio of industrial oils, greases, cutting oils, gear oils, spindle oils, honing oils and rust preventives — supported by strong technical backing.",
    productHighlights: [
      "Cutting oils: Cut-400, Multicut-B, Procut-SS, ST Cut 678",
      "Gear oils: 220, 320, EP-90 (GL-4)",
      "Way lubricants, spindle oils, honing oils",
      "Anti-rust products: OB 60, DW 175",
    ],
    products: [
      { name: "Gear Oil 220", spec: "ISO VG 220 Industrial Gear Oil", size: "Barrel", image: "/images/products/divyol/gear-oil-220.png" },
      { name: "Gear SPL 320", spec: "Gear Special ISO VG 320", size: "26 L", image: "/images/products/divyol/gear-spl-320.png" },
      { name: "Cut-400", spec: "Soluble Cutting Oil", size: "Drum", image: "/images/products/divyol/cut-400-drum.png" },
      { name: "Cut-400", spec: "Soluble Cutting Oil", size: "26 L", image: "/images/products/divyol/cut-400-26l.png" },
      { name: "Multicut-B", spec: "Multi-metal Cutting Oil", size: "50 L", image: "/images/products/divyol/multicut-b-50l.png" },
      { name: "Procut-SS", spec: "Semi-Synthetic Cutting Oil", size: "26 L", image: "/images/products/divyol/procut-ss-26l.png" },
      { name: "Hone Oil 981", spec: "Honing Oil", size: "20 L", image: "/images/products/divyol/hone-oil-981.png" },
      { name: "Way Lube 32 / 68", spec: "Slideway Lubricant ISO VG 32/68", size: "Various", image: "/images/products/divyol/way-lube-32-68.png" },
      { name: "Spindle Oil 12", spec: "ISO VG 12 Spindle Oil", size: "20 L", image: "/images/products/divyol/spindle-oil-12.png" },
      { name: "ST Cut 678", spec: "Neat Cutting Oil", size: "20 L", image: "/images/products/divyol/st-cut-678.png" },
      { name: "EP-90 GL-4", spec: "SAE 90 Spine EP Gear Oil", size: "20 L", image: "/images/products/divyol/ep90-gl4.png" },
    ],
    grades: {
      title: "Divyol Grades & Types",
      columns: ["Category", "Grades"],
      rows: [
        ["Hydraulic Oils", "VG 32, VG 46, VG 68"],
        ["Gear Oils", "VG 220, VG 320"],
        ["Cutting Fluids", "Cut-400, Multicut-B, Procut-SS, ST Cut 678"],
        ["Spindle Oils", "VG 12"],
        ["Way Lubricants", "VG 32, VG 68"],
        ["Rust Preventives", "Antirust OB 60, Antirust DW 175"],
        ["Greases", "EP-3 Industrial Grease"],
      ],
    },
  },
  {
    id: "kolchen",
    name: "Kolchen",
    logo: "/images/brands/kolchen.png",
    category: "Band Saw Blades",
    tagline: "Bi-metal band saw blades engineered for precision sawing.",
    description:
      "Kolchen bi-metal band saw blades deliver clean, straight, high-productivity cuts on structural and solid materials. Available in Structut, Structut Plus, Supreme and Xpert series.",
    productHighlights: [
      "Series: Structut · Structut Plus · Supreme · Xpert",
      "Widths from 19 mm to 80 mm",
      "For structural sawing, production cutting, HSS-cutting applications",
    ],
    products: [
      { name: "Kolchen Band Saw Blade", spec: "Bi-metal, Precision Sawing", size: "Full Range 19–80 mm", image: "/images/products/kolchen/band-saw-blade.jpeg" },
    ],
    grades: {
      title: "Available Sizes",
      columns: ["Width × Thickness (mm)", "Recommended Use"],
      rows: [
        ["19 × 0.9", "Small production saws"],
        ["27 × 0.9", "Light structural cutting"],
        ["34 × 1.1", "General purpose"],
        ["41 × 1.3", "Medium-duty steel cutting"],
        ["54 × 1.6", "Heavy-duty solid bar"],
        ["67 × 1.6", "Large bar / heavy sections"],
        ["80 × 1.6", "Extra heavy-duty"],
      ],
    },
  },
  {
    id: "evershine",
    name: "Evershine",
    logo: "/images/brands/evershine.png",
    category: "Circular Saw Cutters",
    tagline: "Your Partner for Metal Cutting Solutions.",
    description:
      "Evershine circular saw cutters deliver clean, burr-free cuts on pipes, tubes and bar stock — available across 250 mm to 460 mm diameters.",
    productHighlights: [
      "Diameters: 250 · 285 · 315 · 360 · 420 · 460 mm",
      "For pipe / tube / bar cutting on cold-saw machines",
      "High-speed steel and TCT variants",
    ],
    products: [
      { name: "Evershine Circular Saw Cutter", spec: "Metal Cutting Blade", size: "Range 250 – 460 mm", image: "/images/products/evershine/circular-saw-cutter.png" },
    ],
    grades: {
      title: "Available Diameters",
      columns: ["Diameter (mm)"],
      rows: [["250"], ["285"], ["315"], ["360"], ["420"], ["460"]],
    },
  },
  {
    id: "bpt-birla-precision",
    name: "BPT — Birla Precision",
    logo: "/images/brands/bpt-birla.png",
    category: "Precision Tooling & ISO Inserts",
    tagline: "Precision machining solutions from a legacy Indian tooling group.",
    description:
      "Birla Precision Technologies is one of India's leading precision tooling groups — supplying carbide inserts, tool holders, drilling and milling systems for CNC and conventional machining.",
    productHighlights: [
      "ISO turning inserts: CNMG, DNMG, TNMG, WNMG, SNMG, VNMG",
      "Milling inserts: APKT, SEKT, RPMT",
      "Finish-turning: VBMT, CCMT, DCMT",
      "Tool holders, boring bars & threading tools",
    ],
    products: [
      { name: "ISO Turning Insert CNMG 120408-PM", spec: "ISO Standard Precision · High Wear Resistance", size: "CNMG series", image: "/images/products/bpt/iso-turning-insert.png" },
    ],
    grades: {
      title: "ISO Insert Shapes We Supply",
      columns: ["Series", "Operation", "Common Sizes"],
      rows: [
        ["CNMG", "Turning", "080304 / 120404 / 120408 / 160608"],
        ["DNMG", "Turning", "110404 / 150604 / 150608"],
        ["TNMG", "Turning", "160404 / 160408 / 220408"],
        ["WNMG", "Turning", "060404 / 080404 / 080408"],
        ["SNMG", "Turning", "120404 / 120408 / 150612"],
        ["VNMG", "Turning", "160404 / 160408"],
        ["VBMT / CCMT / DCMT", "Finish turning", "As per requirement"],
        ["APKT / SEKT / RPMT", "Milling", "As per requirement"],
      ],
    },
  },
  {
    id: "birla-durotool",
    name: "Birla Durotool",
    logo: "/images/brands/birla-durotool.png",
    category: "Cutting Tools, Abrasives & Circular Saws",
    parent: "Birla Precision Group",
    tagline: "Full-range cutting tools, drilling systems and abrasives.",
    description:
      "Birla Durotool delivers a comprehensive range of drilling, cutting and abrasive products — from hammer drills and annular cutters to TCT circular saws, chopsaw wheels and depressed-centre discs.",
    productHighlights: [
      "Hammer & Masonry drills, Annular Cutters, Carbide Tip Drills",
      "Steel files, HSS twist drills, H-Series drills",
      "Ultra-thin cutting wheels, Chopsaw wheels, Depressed centre discs",
      "TCT circular saws 250 – 450 mm",
    ],
    products: [
      { name: "Depressed Centre Grinding Wheel", spec: "EN12413 · 27-A30 RBF · 80M/S", size: "100 × 6 × 16 mm", image: "/images/products/birla-durotool/depressed-centre-disc.jpeg" },
      { name: "Carbide Tip Masonry Drills", spec: "For concrete & masonry", size: "3 – 25 mm", image: "/images/products/birla-durotool/carbide-tip-drills.jpeg" },
      { name: "TCT Circular Saw (Wood)", spec: "Tungsten Carbide Tipped", size: "5\" × 20 × 30T", image: "/images/products/birla-durotool/tct-circular-saw-wood.jpeg" },
      { name: "Ultra-Thin Cut-Off Wheel", spec: "EN12413 · Metal Cutting", size: "4\" / 5\" / 7\"", image: "/images/products/birla-durotool/cut-off-wheel.jpeg" },
      { name: "Chopsaw Wheel", spec: "For chopsaw machines", size: "14\" (355) / 16\" (405)", image: "/images/products/birla-durotool/chopsaw-wheel.jpeg" },
    ],
    grades: {
      title: "Popular Sizes",
      columns: ["Product", "Sizes"],
      rows: [
        ["TCT Circular Saw", "250 / 300 / 350 / 400 / 450 mm"],
        ["Chopsaw Wheel", "14\" (355 mm) / 16\" (405 mm)"],
        ["Ultra-Thin Cutting Wheel", "4\" / 5\" / 7\""],
        ["Depressed Centre Disc", "4\" / 5\" / 7\""],
        ["Annular Cutter", "12 – 60 mm"],
        ["Carbide Tip Drills", "3 – 25 mm"],
      ],
    },
  },
  {
    id: "itm-dagger",
    name: "Indian Tool Mfrs. (Dagger Brand)",
    logo: "/images/brands/dagger.png",
    category: "HSS Cutting Tools & Precision Tooling",
    tagline: "Since 1937 — legacy HSS cutting tools built for productivity.",
    description:
      "Indian Tool Manufacturers (Dagger Brand) is one of India's oldest cutting-tool makers. Their HSS twist drills, taps, reamers, milling cutters, engineering files and specialised tools are trusted across the country.",
    productHighlights: [
      "HSS Twist Drills 1–25 mm · Centre Drills · Reamers 3–25 mm",
      "Milling Cutters, Screwing Taps (M3–M20)",
      "Solid Carbide Drills, Solid Carbide End Mills 2–20 mm",
      "Engineering Files, Hand Tool Bits, Annular Cutters, Grooving Tools",
    ],
    products: [
      { name: "HSS Twist Drills", spec: "General Purpose", size: "1 – 25 mm", image: "/images/products/itm/hss-twist-drills.jpeg" },
      { name: "HSS Twist Drills — Coated & Standard", spec: "Multi-material drilling", size: "Assorted", image: "/images/products/itm/hss-twist-drills-varied.jpeg" },
      { name: "Centre Drills", spec: "Type A / B", size: "1 – 10 mm", image: "/images/products/itm/centre-drills.jpeg" },
      { name: "Solid Carbide Drills — ITM SC-Drill", spec: "TiN / TiCN Coated", size: "3 – 20 mm", image: "/images/products/itm/solid-carbide-drills.jpeg" },
      { name: "Solid Carbide Drills", spec: "Precision Drilling", size: "3 – 20 mm", image: "/images/products/itm/solid-carbide-drills-basic.jpeg" },
      { name: "Solid Carbide End Mills", spec: "TiN / TiCN Coated", size: "2 – 20 mm", image: "/images/products/itm/end-mills.jpeg" },
      { name: "Solid Carbide Ball Nose End Mills", spec: "For 3D contouring", size: "2 – 16 mm", image: "/images/products/itm/ball-nose-end-mills.jpeg" },
      { name: "Reamers", spec: "Machine / Hand", size: "3 – 25 mm", image: "/images/products/itm/reamers.jpeg" },
      { name: "Milling Cutters (Bore / Shank)", spec: "HSS / Cobalt", size: "4 – 20 mm", image: "/images/products/itm/milling-cutters.jpeg" },
      { name: "Screwing Taps", spec: "HSS Taps · TiN Coated", size: "M3 – M20", image: "/images/products/itm/screwing-taps.jpeg" },
      { name: "Annular Cutter (Large)", spec: "Broaching Cutter", size: "12 – 60 mm", image: "/images/products/itm/annular-cutter-large.jpeg" },
      { name: "Annular Cutter", spec: "HSS-Co Broach", size: "12 – 60 mm", image: "/images/products/itm/annular-cutter.jpeg" },
      { name: "Engineering Files", spec: "Precision Files with Handles", size: "Multiple cuts", image: "/images/products/itm/masonry-drills.jpeg" },
      { name: "Files & Grooving Tools", spec: "Steel Files", size: "Assorted", image: "/images/products/itm/files-grooving.jpeg" },
      { name: "Hand Tool Bits", spec: "HSS Tool Bits", size: "Assorted sizes", image: "/images/products/itm/hand-tool-bits.jpeg" },
    ],
    grades: {
      title: "ITM Popular Ranges",
      columns: ["Tool", "Range"],
      rows: [
        ["HSS Twist Drills", "1 – 25 mm"],
        ["HSS Centre Drills (Type A / B)", "1 – 10 mm"],
        ["Screwing Taps", "M3 – M20"],
        ["Reamers", "3 – 25 mm"],
        ["Solid Carbide End Mills", "2 – 20 mm"],
        ["Solid Carbide Drills", "3 – 20 mm"],
        ["Milling Cutters (Bore / Shank)", "4 – 20 mm"],
      ],
    },
  },
  {
    id: "torpedo-panther",
    name: "Torpedo — Panther Taps",
    logo: "/images/brands/torpedo.png",
    category: "Precision Taps & Threading Tools",
    parent: "ITM Division",
    tagline: "Precision Machining Taps built for productivity.",
    description:
      "Panther Taps (an ITM Torpedo division) supply high-performance spiral flute, spiral point, roll form and cast-iron taps with TiN, TiCN and Ti(AI)N coatings — for reliable threading across steel, cast iron and non-ferrous materials.",
    productHighlights: [
      "Spiral Flute Taps · Spiral Point Taps",
      "Roll Form Taps · Cast Iron (St. Flute) Taps",
      "Coatings: TiN · TiCN · Ti(AI)N",
      "Range: M3 – M16",
    ],
    products: [
      { name: "Spiral Flute Taps", spec: "TiN / TiCN Coated", size: "M3 – M16", image: "/images/products/panther-taps/spiral-flute.png" },
      { name: "Spiral Point Taps", spec: "For through-holes", size: "M3 – M16", image: "/images/products/panther-taps/spiral-point.png" },
      { name: "Roll Form Taps", spec: "Chipless forming", size: "M3 – M16", image: "/images/products/panther-taps/roll-form.png" },
      { name: "Cast Iron (St. Flute) Taps", spec: "For cast iron", size: "M3 – M16", image: "/images/products/panther-taps/cast-iron.png" },
    ],
    grades: {
      title: "Tap Types & Coatings",
      columns: ["Type", "Suited For", "Coating Options"],
      rows: [
        ["Spiral Flute", "Blind holes in steel", "TiN, TiCN, Ti(AI)N"],
        ["Spiral Point", "Through holes in steel", "TiN, TiCN"],
        ["Roll Form", "Non-chipping (formed thread)", "TiN, TiCN"],
        ["St. Flute (Cast Iron)", "Cast iron / brittle", "Uncoated, TiN"],
      ],
    },
  },
  {
    id: "carbomach",
    name: "CarboMach",
    logo: "/images/brands/carbomach.png",
    category: "Solid Carbide Cutting Tools",
    tagline: "Precision solid carbide tools for CNC machining.",
    description:
      "CarboMach specialises in solid carbide end mills, drills and precision cutting tools designed for high-productivity CNC machining and demanding materials.",
    productHighlights: [
      "Solid Carbide End Mills 2 – 20 mm",
      "Carbide Drills 3 – 20 mm",
      "Precision CNC cutting tools",
      "Milling & drilling solutions for hardened materials",
    ],
    products: [
      { name: "Solid Carbide End Mill", spec: "CNC Milling · TiN / TiCN Coated", size: "2 – 20 mm", image: "/images/products/itm/end-mills.jpeg" },
      { name: "Solid Carbide Ball Nose End Mill", spec: "3D contour & mould milling", size: "2 – 16 mm", image: "/images/products/itm/ball-nose-end-mills.jpeg" },
      { name: "Solid Carbide Drill", spec: "High-speed Drilling · Coated", size: "3 – 20 mm", image: "/images/products/itm/solid-carbide-drills.jpeg" },
    ],
    grades: {
      title: "CarboMach Range",
      columns: ["Product", "Range"],
      rows: [
        ["Carbide End Mills", "2 – 20 mm"],
        ["Carbide Drills", "3 – 20 mm"],
      ],
    },
  },
  {
    id: "argus",
    name: "Argus",
    logo: "/images/brands/argus.png",
    category: "Safety & Industrial Consumables",
    tagline: "A Company of Quality — safety, PPE and industrial consumables.",
    description:
      "Argus supplies industrial safety and consumables — including hand protection, safety wear and maintenance consumables used across foundries, machine shops and process plants.",
    productHighlights: [
      "Nitrile gripper gloves, examination gloves",
      "Woollen hand gloves (40 / 70 / 80 GSM)",
      "Leather + cotton work gloves, safety masks",
      "Industrial safety consumables",
    ],
    products: [
      { name: "Safety & PPE Range", spec: "Hand protection, masks & safety equipment", size: "Assorted", image: "/images/products/generic/safety-materials.jpeg" },
    ],
    grades: {
      title: "Argus Range",
      columns: ["Product", "Variants"],
      rows: [
        ["Examination Gloves", "Blue Nitrile"],
        ["Woollen Hand Gloves", "40 / 70 / 80 GSM"],
        ["Nitrile Gripper Gloves", "Standard / Heavy-duty"],
        ["Leather + Cotton Gloves", "Cut protection"],
        ["Safety Masks", "Yellow / Green"],
      ],
    },
  },
  {
    id: "lubrichem",
    name: "Lubrichem",
    logo: "/images/brands/lubrichem.png",
    category: "Specialty Industrial Lubricants",
    tagline: "Tribology Redefined — specialty lubricants for demanding applications.",
    description:
      "Lubrichem develops specialty lubricants and tribology solutions — high-performance oils, greases and additives that extend equipment life in harsh operating conditions.",
    productHighlights: [
      "Specialty industrial oils",
      "High-performance greases",
      "Custom lubrication solutions",
      "Tribology consulting & support",
    ],
    products: [],
    grades: null,
  },
  {
    id: "emulsichem",
    name: "Emulsichem",
    logo: "/images/brands/emulsichem.png",
    category: "Metal Working Fluids",
    tagline: "Emulsion-based cutting fluids and industrial coolants.",
    description:
      "Emulsichem manufactures a full range of emulsion-based metal working fluids and industrial coolants — engineered for productive machining and long sump life.",
    productHighlights: [
      "Soluble cutting oils",
      "Semi-synthetic coolants",
      "Rust preventives & cleaners",
      "Custom formulations",
    ],
    products: [],
    grades: null,
  },
];

// Ordered brand slug list (for prev/next navigation)
export const BRAND_ORDER = BRANDS.map((b) => b.id);
